import React, { memo } from "react";
import { Box, CircularProgress } from "@mui/material";

const Loading = memo(() => {
  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        width: "100vw",
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#fff",
        zIndex: 2000,
      }}
    >
      <CircularProgress color="secondary" size={34} thickness={4} />
    </Box>
  );
});

export default Loading;
